export default __webpack_public_path__ + "static/media/calendario1.07610fa0.pdf";